import { defineStore } from 'pinia'

export let usePositionStore = defineStore('positionStore', {
  state: () => ({
    searchablePosition: null,
    userPosition: null,
    busStopPosition: null,
    poiPosition: null,
  }),

  actions: {
    setPosition(position) {
      this.clearBusStopPosition()
      this.searchablePosition = position
    },
    clearPosition() {
      this.searchablePosition = null
    },
    setUserPosition(position) {
      this.userPosition = position
    },
    setBusStopPosition(position) {
      this.clearPosition()
      this.busStopPosition = position
    },
    clearBusStopPosition() {
      this.busStopPosition = null
    },
    setPoiPosition(position) {
      this.clearPosition()
      this.poiPosition = position
    },
    clearPoiPosition() {
      this.poiPosition = null
    },
  },

  getters: {
    hasPosition: (state) => !!state.searchablePosition,
    hasUserPosition: (state) => !!state.userPosition,
    hasBusStopPosition: (state) => !!state.busStopPosition,
    hasPoiPosition: (state) => !!state.poiPosition,
  },
})
